import { z } from 'zod';
/**
 * Kommentare (SPEC 9.1). Obergrenze grosszuegig, aber vorhanden: ohne sie
 * kann ein einziger Beitrag das Kartendetail auf jedem Geraet lahmlegen.
 */
export const commentBodySchema = z.object({
    body: z.string().trim().min(1, 'Kommentar ist leer').max(5000),
});
/** Wie viele Verlaufseintraege eine Abfrage hoechstens liefert. */
export const ACTIVITY_PAGE_SIZE = 50;
export const activityQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(200).default(ACTIVITY_PAGE_SIZE),
});
//# sourceMappingURL=comment.js.map